import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { BooleanDisplay } from './BooleanDisplay';
import { FormFieldBoolean } from '.';

interface Props {
  value: boolean;
  previousValue?: boolean | null;
  onClose: () => void;
  config: FormFieldBoolean;
}

export const BooleanDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const prevZeroState = typeof previousValue !== 'boolean';
  const currentZeroState = typeof value !== 'boolean';
  const labels = config.params.labels;
  const label = labels.main;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {label} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {prevZeroState ? (
          zeroState
        ) : (
          <BooleanDisplay
            value={previousValue}
            subtitle={labels.options?.[previousValue.toString()]?.main}
          />
        )}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {currentZeroState ? (
          zeroState
        ) : (
          <BooleanDisplay
            value={value}
            subtitle={labels.options?.[value.toString()]?.main}
          />
        )}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
